import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
var MissionStatementSection = function MissionStatementSection() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort,
    tLong = _useTranslation.tLong;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: "py-6 px-4 md:pt-16 md:max-w-[1152px] md:mx-auto md:pb-[52px] md:px-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-6 md:flex-row-reverse md:justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-[395px] md:h-[535px] md:w-[565px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/about-us/mission.webp",
    alt: tLong("about_us/mission_alt", {
      ns: "web_common"
    }),
    loading: "lazy",
    className: "w-full h-full object-cover object-center rounded-2xl",
    width: "360",
    height: "395"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-6 md:items-start"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary text-start text-2xl font-bold md:text-[40px] md:leading-[56px] md:max-w-[465px]"
  }, tShort("about_us/mission_title", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", {
    className: "font-regular text-[#576678] text-base text-start md:text-2xl md:leading-10 md:max-w-[465px]"
  }, tLong("about_us/mission_subtitle", {
    ns: "web_common"
  }))))));
};
export default MissionStatementSection;